import {
  FETCH_TRACKING_RECORDS_REQUEST,
  FETCH_TRACKING_RECORDS_SUCCESS,
  FETCH_TRACKING_RECORDS_FAILURE,
  UPDATE_FILTERS,
  UPDATE_PAGINATION,
  FETCH_TRACKING_STATS_REQUEST,
  FETCH_TRACKING_STATS_SUCCESS,
  FETCH_TRACKING_STATS_FAILURE,
  RESET_ERROR
} from './liveUrlTrackingActions';

// Initial State
const initialState = {
  // Data
  records: [],
  statistics: {},
  
  // UI State  
  loading: false,
  error: null,
  statsLoading: false,
  statsError: null,
  
  // Pagination
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    pageSize: 20
  },
  
  // Filters
  filters: {
    rootFolder: [],
    pushedBy: '',
    dateFrom: null,
    dateTo: null,
    fileType: [],
    sortBy: 'pushedAt',
    sortOrder: 'desc'
  }
};

// Reducer
const liveUrlTrackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRACKING_RECORDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_TRACKING_RECORDS_SUCCESS:
      return {
        ...state,
        records: action.payload.records || [],
        pagination: action.payload.pagination || state.pagination,
        loading: false,
        error: null
      };

    case FETCH_TRACKING_RECORDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_TRACKING_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };

    case FETCH_TRACKING_STATS_SUCCESS:
      return {
        ...state,
        statistics: action.payload || {},
        statsLoading: false,
        statsError: null
      };

    case FETCH_TRACKING_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.payload
      };

    case UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };

    case UPDATE_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload
        }
      };

    case RESET_ERROR:
      return {
        ...state,
        error: null,
        statsError: null
      };

    default:
      return state;
  }
};

export default liveUrlTrackingReducer;